/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { eventContractFormDefinitions } from "./eventContractFormDefinitions";
import { membershipContractFormDefinitions } from "./membershipContractFormDefinitions";
import { otherContractFormDefinitions } from "./otherContractFormDefinitions";
import { providerContractFormDefinitions } from "./providerContractFormDefinitions";
import { purchaseContractFormDefinitions } from "./purchaseContractFormDefinitions";
import { serviceContractFormDefinitions } from "./serviceContractFormDefinitions";
import { subscriptionContractFormDefinitions } from "./subscriptionContractFormDefinitions";
import { travelContractFormDefinitions } from "./travelContractFormDefinitions";
import { vehicleContractFormDefinitions } from "./vehicleContractFormDefinitions";
import { settlementFormDefinitions } from "./settlementFormDefinitions";
import { divorceFormDefinitions } from "./divorceFormDefinitions";
import { preleadFormDefinitions } from "./preleadFormDefinitions";
import { alimonyFormDefinitions } from "./alimonyFormDefinitions";
import _ from "lodash";
import {dataLeakContractFormDefinitions} from "./dataLeakContractFormDefinitions";
import {trafficAccidentFormDefinitions} from "./trafficAccidentFormDefinitions";

const formDefinitions: any = {
  eventContract: eventContractFormDefinitions,
  membershipContract: membershipContractFormDefinitions,
  otherContract: otherContractFormDefinitions,
  providerContract: providerContractFormDefinitions,
  dataLeakContract: dataLeakContractFormDefinitions,
  purchaseContract: purchaseContractFormDefinitions,
  serviceContract: serviceContractFormDefinitions,
  subscriptionContract: subscriptionContractFormDefinitions,
  travelContract: travelContractFormDefinitions,
  vehicleContract: vehicleContractFormDefinitions,
  divorce: divorceFormDefinitions,
  settlement: settlementFormDefinitions,
  alimony: alimonyFormDefinitions,
  traffic: {},
  trafficAccident: trafficAccidentFormDefinitions,
  processCostSupport: {},
  prelead: preleadFormDefinitions,
};

export function getFormDefinitions(values: any, fieldPath: string) {
  if (_.get(formDefinitions[values.name], fieldPath)) {
    return _.get(formDefinitions[values.name], fieldPath)(values);
  }
  return {};
}
